import { Skeleton } from '@mantine/core';

export const AIChatPanelSkeleton = () => {
  return (
    <div className="flex h-full flex-col gap-5 p-3">
      <Skeleton height={80} />
      <Skeleton height={80} />
      <Skeleton height={80} />
      <Skeleton height={80} />
    </div>
  );
};
